module.exports = __webpack_public_path__ + "assets/img/SFT_samsung-02.0b634521.png";